export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  let index = newState.index
  if(payload.indexBlockData !== undefined) {
    index = payload.indexBlockData + 1
    payload = Object.assign({}, payload)
  }

  const sorts = newState.pageDataUi
                        .map(o => o.sort)
                        .filter(s => typeof s === 'number');

  const maxSort = sorts.length ? Math.max(...sorts) : 0;

  payload.sort = maxSort + 1;

  newState.pageDataUi.splice(index, 0, payload);

  newState.pageDataUi = [...newState.pageDataUi]

  return newState;
};
